import React, { useState } from "react";
import { observer } from "mobx-react";
import Button from "Components/common/Button";
import { ReactComponent as LinkedinIcon } from "./svg/linkedIn.svg";
import { ReactComponent as LinkedinPremiumIcon } from "./svg/liPremiumIcon.svg";
import { ReactComponent as EmptyLinkedInIcon } from "./svg/emptyLinkedIn.svg";
import userDetail from "Stores/userDetail";
import UpgradeIconTooltip from "Components/Paywall/UpgradeIconTooltip";
import PaywallUtils from "Utils/PaywallUtils";
import linkedInUtils from "./common/linkedInUtils";
import { addLinkedInAccountPopupState } from "Components/PreviewPopup/AddLinkedInAccountPopup";
import { linkedInReplyState } from "./state";

const ConnectLinkedInButton = observer((props = {}) => {
  const {
    inFreePlan = false,
    planName = "",
    liAutomationEnabled = false
  } = userDetail?.userFeatureFlag || {};

  const [tooltipType, setTooltipType] = useState("");

  const PaywallForButton = observer(props => {
    const { type = "" } = props || {};

    return (
      !liAutomationEnabled && (
        <span className="wrapLockIcon">
          <UpgradeIconTooltip
            plan={PaywallUtils.getPlanName(planName, inFreePlan)}
            type={"linkedInSettings"}
            enableTooltip={true}
            alignTooltip="topRight"
            customToggle={true}
            toggleCbkVal={tooltipType === type}
          />
        </span>
      )
    );
  });

  const handleAddLinkedInAccount = async () => {
    const { isLimitReached = false, liAutomationEnabled = false } =
      await linkedInReplyState.getCurrentTeam();
    if (!liAutomationEnabled) {
      PaywallUtils.upgradeUtilsFunction("linkedInAutomationNotEnabled", false);
      return;
    }
    if (isLimitReached) {
      PaywallUtils.upgradeUtilsFunction("multipleLinkedInCustom", false);
    } else {
      addLinkedInAccountPopupState.setShowPopup(true);
    }
  };

  const addLinkedInAccountBtnProps = {
    id: "addLinkedInAccountBtn",
    name: "addLinkedInAccountBtn",
    btnText: "Connect LinkedIn",
    type: "button",
    className: "addLinkedInAccountBtn",
    click: handleAddLinkedInAccount
  };

  return (
    <div className="liConnectWrapper">
      <EmptyLinkedInIcon />
      <h6>Add your LinkedIn account</h6>
      <div className="liButtonWrapper">
        <Button {...addLinkedInAccountBtnProps} />
      </div>
    </div>
  );
});

export { ConnectLinkedInButton };
export default ConnectLinkedInButton;
